import { assertNever } from '@kofno/piper';
import { fromNullable } from 'maybeasy';

interface PageNumber {
  kind: 'page';
  page: number;
}

interface Gap {
  kind: 'gap';
  after: number;
}

export type PageItem = PageNumber | Gap;

const pageNumber = (page: number): PageNumber => ({ kind: 'page', page });

const gap = (after: number): Gap => ({ kind: 'gap', after });

const isListed = (page: number, current: number, total: number): boolean =>
  page === 1 || page === total || Math.abs(page - current) <= 1;

const appendGap = (items: ReadonlyArray<PageItem>, page: number): ReadonlyArray<PageItem> =>
  fromNullable(items[items.length - 1])
    .map((last): ReadonlyArray<PageItem> => {
      switch (last.kind) {
        case 'gap':
          return items;
        case 'page':
          return [...items, gap(page - 1)];
        default:
          return assertNever(last);
      }
    })
    .getOrElseValue(items);

/** First, last, and the current page plus one on each side, with gaps between. */
export const pageItems = (current: number, total: number): ReadonlyArray<PageItem> =>
  Array.from({ length: total }, (_, i) => i + 1).reduce<ReadonlyArray<PageItem>>(
    (items, page) =>
      isListed(page, current, total) ? [...items, pageNumber(page)] : appendGap(items, page),
    [],
  );
